import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './styles/EditDescription.scss';
import { copy, cutoffs } from '../../constants';

class EditDescription extends Component {
    constructor() {
        super();
        this.textArea = React.createRef();
        this.onChange = this.onChange.bind(this);
    }

    componentDidMount() {
        this._autoSize(this.textArea);
    }

    componentDidUpdate() {
        this._autoSize(this.textArea);
    }

    _autoSize(textArea) {
        // Note: This has to be done on 2 lines
        // setting 'height:auto' --> makes 'scrollHeight' === 'height of text'
        // setting 'height:scrollHeight' -> makes 'height' === 'height of text'
        textArea.style.cssText = 'height: auto; padding: 0';
        textArea.style.cssText = `height: ${textArea.scrollHeight}px`;
    }

    formatDescription = description => {
        return description.slice(0, cutoffs.MAX_CHAR_DESCRIPTION);
    };

    onChange(e) {
        const { value } = e.currentTarget;
        this.props.setPortfolioDescription(this.formatDescription(value));
    }

    render() {
        const { newPortfolioDescription } = this.props;
        const charCount = newPortfolioDescription.length;

        return (
            <div className={styles.textAreaWrapper}>
                <textarea
                    ref={el => {
                        this.textArea = el;
                    }}
                    onChange={this.onChange}
                    value={newPortfolioDescription}
                    maxLength={cutoffs.MAX_CHAR_DESCRIPTION}
                    placeholder={copy.addDescription.PLACEHOLDER}
                    className={styles.textArea}
                />
                <p className={styles.charCount}>{`${charCount}/${cutoffs.MAX_CHAR_DESCRIPTION}`}</p>
            </div>
        );
    }
}

EditDescription.propTypes = {
    newPortfolioDescription: PropTypes.string,
    setPortfolioDescription: PropTypes.func,
};

export { EditDescription };
